<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <path fill="#E1F5FE" d="M27.153 25.556H3.194V3.194h23.959v7.987l7.986-5.99v18.368l-7.986-5.99v7.987z" transform="translate(-164 -329) translate(127 292) translate(37 37) translate(3.833 9.583)" />
              <path fill="#164194" d="M0 0v28.75h30.347v-4.792l4.26 3.195h3.726V1.597h-3.726l-4.26 3.195V0H0zm3.194 3.194h23.959v7.987l7.986-5.99v18.368l-7.986-5.99v7.987H3.194V3.194z" transform="translate(-164 -329) translate(127 292) translate(37 37) translate(3.833 9.583)" />
              <path fill="#13A2E8" d="M12.778 18.557L12.778 10.194 21.141 14.375z" transform="translate(-164 -329) translate(127 292) translate(37 37) translate(3.833 9.583)" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>